import { Avatar, Card, Flexbox } from '@/components'
import documentNumberMask from '@/lib/masks/documentNumber'
import phoneNumber from '@/lib/masks/phoneNumber'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

function PersonCard({
  icon, message, person, title, extraData, footer,
}) {
  return (
    <Card.Base>
      <Card.Header>
        <Flexbox.Columns className="align-center">
          <Flexbox.Column>
            <div className="h5">{title}</div>
          </Flexbox.Column>
          <Flexbox.Column className="col-auto">
            <i className={icon} />
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        {
          person ? (
            <>
              <Flexbox.Columns>
                <Flexbox.Column className="col-auto">
                  <Avatar
                    avatarSize="lg"
                    name={person?.fullName}
                    photoURL={person?.photoURL}
                    alt="Imagem de usuário"
                  />
                </Flexbox.Column>
                <Flexbox.Column>
                  <Link to={`/app/users/${person?.id}`}>
                    <div className="text-primary text-bold">{person?.fullName}</div>
                  </Link>
                  <div className="text-small">{person?.documentNumber ? documentNumberMask(person?.documentNumber) : '-'}</div>
                </Flexbox.Column>
              </Flexbox.Columns>
              <div className="divider" />
              <Flexbox.Columns className="mb-1">
                <Flexbox.Column>E-mail</Flexbox.Column>
                <Flexbox.Column className="col-auto text-bold">
                  {person?.email || '-'}
                </Flexbox.Column>
              </Flexbox.Columns>
              <Flexbox.Columns className="mb-1">
                <Flexbox.Column>Fone</Flexbox.Column>
                <Flexbox.Column className="col-auto text-bold">
                  {phoneNumber(person?.phoneNumber) || '-'}
                </Flexbox.Column>
              </Flexbox.Columns>
            </>
          ) : (
            <>
              <div>{message}</div>
              {
                Boolean(extraData?.personName || extraData?.personPhoneNumber) && (
                  <>
                    <div className="divider" />
                    <Flexbox.Columns className="mb-1">
                      <Flexbox.Column>Nome informado</Flexbox.Column>
                      <Flexbox.Column className="col-auto text-bold">
                        {extraData?.personName || '-'}
                      </Flexbox.Column>
                    </Flexbox.Columns>
                    <Flexbox.Columns className="mb-1">
                      <Flexbox.Column>Telefone informado</Flexbox.Column>
                      <Flexbox.Column className="col-auto text-bold">
                        {phoneNumber(extraData?.personPhoneNumber) || '-'}
                      </Flexbox.Column>
                    </Flexbox.Columns>
                  </>
                )
              }
            </>
          )
        }
      </Card.Body>
      {
        Boolean(footer)
        && (
          <Card.Footer>
            {footer}
          </Card.Footer>
        )
      }
    </Card.Base>
  )
}

PersonCard.propTypes = {
  extraData: PropTypes.objectOf(Object),
  footer: PropTypes.node,
  icon: PropTypes.string,
  message: PropTypes.string,
  person: PropTypes.objectOf(Object),
  title: PropTypes.string.isRequired,
}

PersonCard.defaultProps = {
  extraData: null,
  footer: null,
  icon: 'fas fa-user',
  message: 'Nenhum cadastro vinculado.',
  person: null,
}

export default PersonCard
